import React from 'react';
import useAppContext from '../../contexts/UseAppContext';
import Currency from '../../config/Currency';
import CurrencyFormat from 'react-currency-format';
import './PricesBox.css';

function PricesBox({product, mode}) {
    const context = useAppContext();
    const currencyFormat = Currency.CLP;

    const containerStyle = () => {
        let boxShadow;
        let borderRadius;
        switch (mode) {
            case 'product':
                boxShadow = '0 0 10px rgba(0, 0, 0, 0.09)';
                borderRadius = 15;
                break;
            case 'cart':
                boxShadow = '0 0 10px rgba(0, 0, 0, 0.09)';
                borderRadius = 0;
                break;
            case 'cartItem':
                boxShadow = 'unset';
                borderRadius = 0;
                break;
            default:
                boxShadow = 'unset';
                borderRadius = 0;
                break;
        }
        return {
            maxHeight: context.pricesBoxMaxHeight,
            boxShadow: boxShadow,
            borderRadius: borderRadius
        };
    };

    const renderPrice = (price, label, type, discount) => {
        return (
            <div className={`prices-box_price-container ${type}`}>
                <div className='prices-box_price-wrapper'>
                    <span>{label}</span>
                    <div className={`prices-box-info-discount${discount ? '' : ' hidden'}`}>{discount ? `${discount}%` : ''}</div>
                </div>
                <div className={`prices-box_price ${type}`}>
                    <CurrencyFormat
                        prefix={currencyFormat.prefix}
                        suffix={currencyFormat.suffix}
                        thousandSeparator={currencyFormat.thousandsSeparator}
                        decimalSeparator={currencyFormat.decimalSeparator}
                        decimalScale={currencyFormat.decimalScale}
                        value={price}
                        displayType='text'
                    />
                </div>
            </div>
        );
    };

    return (
        <div className='prices-box' style={containerStyle()}>
            {product.hasAnyPrice() && (
                <div className='prices-box_list'>
                    {product.normalPrice && product.normalPrice !== product.offerPrice ?
                        renderPrice(product.normalPrice, 'Público General', product.offerPrice ? 'normal' : 'offer', undefined)
                    : undefined}
                    {product.offerPrice ?
                        renderPrice(product.offerPrice, 'Oferta General', 'offer', product.getOfferDiscountPercentage())
                    : undefined}
                    {product.exclusivePrice ?
                        renderPrice(
                            product.exclusivePrice,
                            'Cliente Entel',
                            'exclusive',
                            product.normalPrice ? product.getExclusiveDiscountPercentage() : (product.offerPrice ? product.getExclusiveDiscountFromOfferPercentage() : undefined)
                        )
                    : undefined}
                </div>
            )}
            {!product.hasAnyPrice() && (
                <div className='prices-box_no-price'>Precio no disponible</div>
            )}
        </div>
    );
}

export default PricesBox;